<template>
  <LayoutGradient :title="pageTitle" icon="fa-file-signature">
    <template v-slot:headerRight>
      <b-btn variant="outline-info" @click="$router.back()">
        <i class="fas fa-arrow-left"/> {{ $t('sideBar.voltar') }}
      </b-btn>
    </template>
    <b-card class="m-3 mt-n10">
      <b-form @submit="onSubmit">
        <b-form-group
            :label="$t('credential.form.fields.empresa.label')"
            label-for="input-company"
            :description="$t('credential.form.fields.empresa.description')"
        >
          <b-overlay :show="store_companies_loading">
            <SelectComponent
                  id="input-company"
                  :model="credential.company"
                  :options="store_companies | idNameToValueLabel"
                  @search="evt => {autocomplete('corecompanies', evt)}"
                  @input="evt => setCredential('company', evt)"
              />
            </b-overlay>
        </b-form-group>
        <b-form-group :label="$t('credential.form.fields.nome.label')" label-for="input-name">
          <b-form-input id="input-name" v-model="credential.name" type="text"/>
        </b-form-group>
        <b-form-group :label="$t('credential.form.fields.usuario.label')" label-for="input-username">
          <b-form-input id="input-username" v-model="credential.username" type="text"/>
        </b-form-group>
        <b-form-group :label="$t('credential.form.fields.senha.label')" label-for="input-password">
          <b-form-input id="input-password" v-model="credential.password" type="text"/>
        </b-form-group>
        <b-form-group :label="$t('credential.form.fields.entidade.label')" label-for="input-entity">
          <b-form-input id="input-entity" v-model="credential.entity" type="text"/>
        </b-form-group>

        <b-form-group
            :label="$t('credential.form.fields.homologacao.label')"
            label-for="input-stage"
            :description="$t('credential.form.fields.homologacao.description')">
          <b-form-checkbox id="input-stage"
                           v-model="credential.stage"
                           value="homologation"
                           unchecked-value="production"
                           size="lg" switch/>
        </b-form-group>
        <b-form-group
            :label="$t('credential.form.fields.status.label')"
            label-for="input-status"
            :description="$t('credential.form.fields.status.description')">
          <b-form-checkbox id="input-status"
                           v-model="credential.status"
                           size="lg" switch/>
        </b-form-group>
        <b-button type="submit" variant="success">
          <i class="fas fa-save"/> {{ $t('credential.form.fields.botao_salvar') }}
        </b-button>
      </b-form>
    </b-card>
  </LayoutGradient>
</template>

<script>
import LayoutGradient from "@/templates/LayoutGradient";
import CredentialRepository from '@/repositories/vns/CredentialRepository'
import SelectComponent from "@/components/SelectComponent";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "Form",
  components: {
    LayoutGradient,
    SelectComponent
  },
  data() {
    return {
      credential_id: null
    }
  },
  computed: {
    ...mapGetters({
      credential: 'credential/current',
      isLoading: 'credential/isLoading',
      store_companies: 'corecompanies/all',
      store_companies_loading: 'corecompanies/isLoading',
    }),
    pageTitle() {
      if (this.credential_id) return this.$t('credential.form.titulo_pagina.editar')
      return this.$t('credential.form.titulo_pagina.criar')
    },
    companies() {
      if (this.store_companies && Array.isArray(this.store_companies)) {
        return this.store_companies.map((company) => {
          return {
            text: company.name,
            value: company.id
          }
        })
      }
      return [];
    }
  },
  methods: {
    ...mapActions([
      'credential/listOne',
      'corecompanies/listAll',
      'corecompanies/search'
    ]),
    setCredential(key, value) {
      this.$store.commit('credential/setCurrent', {...this.credential, [key]: value})
    },
    async onSubmit(evt) {
      evt.preventDefault()
      if (this.$route.params.id) {
        this.update()
      } else {
        this.create()
      }
    },
    create() {
      if (this.credential.company) {
        this.credential.company_id = (this.credential.company.value) ? this.credential.company.value : this.credential.company_id ;
      } else {
        this.setCredential('company_id', null)
        this.setCredential('company', null)
      }

      CredentialRepository.post({
        ...this.credential,
        status: this.credential.status ? this.credential.status : false,
        stage: this.credential.stage ? this.credential.stage : 'homologation'
      }).then(response => {
        this.$snotify.success(this.$t('credential.form.create.success'))
        // evt.target.reset()
        this.$router.push({name: 'vns.credential'})
      }).catch(error => {
        this.$snotify.error(this.$t('credential.form.create.error'))
        if (error.response.status === 422) {
          CredentialRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    },
    update() {
      if (this.credential.company) {
        this.credential.company_id = (this.credential.company.value) ? this.credential.company.value : this.credential.company_id ;
      } else {
        this.setCredential('company_id', null)
        this.setCredential('company', null)
      }
      
      CredentialRepository.put(this.credential_id, this.credential).then(response => {
        this.$snotify.success(this.$t('credential.form.update.success'))
        this.$router.push({name: 'vns.credential'})
      }).catch(error => {
        this.$snotify.error(this.$t('credential.form.update.error'))
        if (error.response.status === 422) {
          CredentialRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    },
    async autocomplete(entityString, string) {
      if (string && string.length >= 3 && !this.awaitingSearch) {
        setTimeout(() => {
          this.temporallyStringPrepareToSQL('name', string).map(async array => {
            await this[`${entityString}/search`]({filters: [array]})
          })
          this.awaitingSearch = false
        }, 1000)
        this.awaitingSearch = true
      }
    },
    temporallyStringPrepareToSQL(field, valueTyped) {
      return [
        [field, 'LIKE', '%' + valueTyped + '%']
      ];
    }
  },
  async mounted() {
    this.$store.commit('credential/setCurrent', {})
    await this['corecompanies/listAll']()
    if (this.$route.params.id) {
      this.credential_id = this.$route.params.id
      await this['credential/listOne'](this.$route.params.id)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
